import { Fragment, ReactNode } from 'react';
import { InjectionConfig, OverrideConfig } from './types';

export const normalizeId = (value: unknown) =>
    typeof value === 'string' ? value : value ? String(value) : undefined;

export const matchesEntry = (
    entry: { id?: string; index?: number; idType?: 'hash' | 'itemId' } | undefined,
    itemId: string | undefined,
    hash: string | undefined,
    index: number,
) => {
    if (!entry) {
        return false;
    }
    if (entry.id) {
        if (entry.idType === 'itemId') {
            return entry.id === itemId;
        }
        return entry.id === hash;
    }
    if (typeof entry.index === 'number') {
        return entry.index === index;
    }
    return false;
};

export const resolveOverride = (
    overrides: OverrideConfig[] | undefined,
    itemId: string | undefined,
    hash: string | undefined,
    index: number,
) => {
    if (!overrides || overrides.length === 0) {
        return undefined;
    }
    const byId = overrides.find((override) => override.id && matchesEntry(override, itemId, hash, index));
    if (byId) {
        return byId;
    }
    return overrides.find((override) => typeof override.index === 'number' && override.index === index);
};

export const resolveInjections = (
    injections: InjectionConfig[] | undefined,
    itemId: string | undefined,
    hash: string | undefined,
    index: number,
    position: 'before' | 'after',
): ReactNode[] => {
    if (!injections || injections.length === 0) {
        return [];
    }
    return injections
        .filter(Boolean)
        .filter((injection) => (injection.position ?? 'after') === position)
        .filter((injection) => matchesEntry(injection, itemId, hash, index))
        .map((injection, injectionIndex) => (
            <Fragment key={`${position}-${hash ?? itemId ?? index}-${index}-${injectionIndex}`}>
                {injection.component}
            </Fragment>
        ));
};
